import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function ErrorPage() {
  const [countdown, setCountdown] = useState(15);
  const [exploded, setExploded] = useState(false);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timerInterval);
          setExploded(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timerInterval);
  }, []);

  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, []);

  useEffect(() => {
    if (exploded) {
      const timer = setTimeout(() => {}, 1200);
      return () => clearTimeout(timer);
    }
  }, [exploded]);

  const formattedCountdown = String(countdown).padStart(2, '0');

  return (
    <div className="bg-gray-900 flex flex-col items-center justify-center min-h-screen w-full p-4 sm:p-8 md:p-20 text-white">
      <AnimatePresence>
        {!exploded && (
          <motion.div
            key="error-box"
            initial={{ opacity: 0, scale: 0.8, rotate: -10 }}
            animate={{ opacity: 1, scale: 1, rotate: 2 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-black bg-opacity-80 border-4 border-red-500 shadow-xl p-6 md:p-10 text-center max-w-lg w-full transform hover:rotate-0 transition-transform duration-300 ease-in-out relative z-10"
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-extrabold text-yellow-400 mb-4 animate-text-flash">
              404 ERROR Your Page Has Been Kidnapped by Aliens.
            </h1>

            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-green-400 mb-6 animate-text-flash-slow">
              Have you tried yelling at your screen? That might help.
            </p>

            <div className="w-full bg-gray-700 rounded-full h-4 mb-4 overflow-hidden border border-gray-600">
              <div className="bg-blue-500 h-full w-[99%] animate-pulse" style={{ width: '99%' }}></div>
            </div>
            <p className="text-sm sm:text-base text-gray-400 mb-6">Loading... (stuck at 99% for eternity)</p>

            <p className="text-base sm:text-lg md:text-xl text-red-400 font-bold">
              Page will self-destruct in: 00:{formattedCountdown}
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {exploded && (
          <motion.div
            key="explosion"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 5, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: 'easeOut' }}
            className="absolute inset-0 flex items-center justify-center text-red-500 text-5xl sm:text-6xl md:text-8xl font-extrabold pointer-events-none"
            onAnimationComplete={() => window.location.href = '/projects'}
          >
            💥 BOOM! 💥
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default ErrorPage;